import { render, staticRenderFns } from "./AttachedToARoleAndMoreBadge.vue?vue&type=template&id=21854184&scoped=true"
import script from "./AttachedToARoleAndMoreBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachedToARoleAndMoreBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AttachedToARoleAndMoreBadge.vue?vue&type=style&index=0&id=21854184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21854184",
  null
  
)

export default component.exports